import { createSlice } from '@reduxjs/toolkit';
import { put, takeLatest } from 'redux-saga/effects';

import { getCognito, getUser } from './api';

const initialAuthState = {
  cognito: undefined,
  user: undefined,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState: initialAuthState,
  reducers: {
    fulfillCognito: (state, action) => {
      return {
        ...state,
        cognito: action.payload,
        cognitoFulfilled: true,
      };
    },
    fulfillUser: (state, action) => {
      return {
        ...state,
        user: action.payload,
        userFulfilled: true,
      };
    },
    requestCognito: (state) => {
      return state;
    },
    requestUser: (state) => {
      return state;
    },
    setUser: (state, action) => {
      return {
        ...state, user: action.payload,
      };
    },

    reset: (state, action) => {
      const { email } = action.payload;

      return {
        ...state, email,
      };
    },
    confirmReset: (state, action) => {
      return {
        cognito: action.payload,
        user: undefined,
      };
    },

    signIn: (state, action) => {
      const { cognito, email } = action.payload;

      return {
        cognito,
        email,
      };
    },

    signOut: () => {
      return initialAuthState;
    },

    signUp: (state, action) => {
      const { cognito, email } = action.payload;

      return {
        cognito,
        email,
      };
    },
    confirmSignUp: (state, action) => {
      const { email } = action.payload;

      return {
        email,
      };
    },
  },
});

// function* initialSaga() {
//   yield put(authSlice.actions.requestCognito());
// }

export function* authSaga() {
  // yield fork(initialSaga);

  yield takeLatest('auth/requestCognito', function* requestCognitoSaga() {
    const cognito = yield getCognito();
    yield put(authSlice.actions.fulfillCognito(cognito));
    yield put(authSlice.actions.requestUser());
  });

  yield takeLatest('auth/requestUser', function* requestUserSaga() {
    const user = yield getUser();
    yield put(authSlice.actions.fulfillUser(user));
  });

  yield takeLatest('auth/confirmReset', function* confirmResetSaga() {
    yield put(authSlice.actions.requestUser());
  });

  yield takeLatest('auth/signIn', function* signInSaga() {
    yield put(authSlice.actions.requestUser());
  });

  yield takeLatest('auth/signUp', function* signUpSaga() {
    yield put(authSlice.actions.requestUser());
  });

  yield takeLatest('auth/confirmSignUp', function* confirmSignUpSaga() {
    yield put(authSlice.actions.requestUser());
  });
}
